import { isEmpty, reject } from 'lodash/fp';

import getSaleableProductIds from '../../utils/get-saleable-product-ids';
import ProductActions from '../../actions/product';
import ProductService from '.';

// @ts-expect-error - Automatic, Please fix when editing this file
const fetchAllProductData = (state, dispatch) => {
  const products = state.product.data;
  const saleableProductIds = getSaleableProductIds();
  const productIdsToLoad = reject((productId) => ProductService.getProduct(products, productId), saleableProductIds);

  if (isEmpty(productIdsToLoad)) {
    return Promise.resolve();
  }

  const action = ProductActions.load(productIdsToLoad);
  return dispatch(action);
};

export default fetchAllProductData;
